// Etiqueta de versión mostrada en el diálogo "Acerca de".
// Actualizar en cada release del aplicativo.
export const APP_VERSION_LABEL = "v2.0.0";
